var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDescription = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  className: "logoDescription",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 3,
  width: 17.5881,
  height: 3.05887
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 21,
  width: 17.5881,
  height: 3.05887
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 8,
  width: 25.9998,
  height: 3.05887
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 13.1758,
  width: 25.9998,
  height: 3.05887
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 25.9414,
  width: 25.9998,
  height: 3.05887
})));
export { SvgDescription as ReactComponent };
export default __webpack_public_path__ + "description.bf0e85864e487bdd3a88f6ffb8010361.svg";